import { render, staticRenderFns } from "./BaruDashboard.vue?vue&type=template&id=331d6fd8&"
import script from "./BaruDashboard.vue?vue&type=script&lang=js&"
export * from "./BaruDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports